module.exports = __webpack_public_path__ + "static/media/play-in-circle.d139d944.svg";